var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Moldremediation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220 95C225.523 95 230 90.5228 230 85C230 79.4772 225.523 75 220 75C214.477 75 210 79.4772 210 85C210 90.5228 214.477 95 220 95Z",
    fill: "#9BA3AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.5 75C196.642 75 200 71.6421 200 67.5C200 63.3579 196.642 60 192.5 60C188.358 60 185 63.3579 185 67.5C185 71.6421 188.358 75 192.5 75Z",
    fill: "#9BA3AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210 50C212.761 50 215 47.7614 215 45C215 42.2386 212.761 40 210 40C207.239 40 205 42.2386 205 45C205 47.7614 207.239 50 210 50Z",
    fill: "#9BA3AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200 180C213.807 180 225 168.807 225 155C225 141.193 213.807 130 200 130C186.193 130 175 141.193 175 155C175 168.807 186.193 180 200 180Z",
    fill: "#9BA3AC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M190 165C203.807 165 215 153.807 215 140C215 126.193 203.807 115 190 115C176.193 115 165 126.193 165 140C165 153.807 176.193 165 190 165Z",
    fill: "#9BA3AC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135 170C151.569 170 165 156.569 165 140C165 123.431 151.569 110 135 110C118.431 110 105 123.431 105 140C105 156.569 118.431 170 135 170Z",
    fill: "#9BA3AC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M160 145C176.569 145 190 131.569 190 115C190 98.4315 176.569 85 160 85C143.431 85 130 98.4315 130 115C130 131.569 143.431 145 160 145Z",
    fill: "#9BA3AC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165 190C181.569 190 195 176.569 195 160C195 143.431 181.569 130 165 130C148.431 130 135 143.431 135 160C135 176.569 148.431 190 165 190Z",
    fill: "#9BA3AC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M145 55H30C24.475 55 20 59.475 20 65V195C20 200.525 24.475 205 30 205H120C139.33 205 155 189.33 155 170V65C155 59.475 150.525 55 145 55Z",
    fill: "#0B5BA4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M155 70H35V190H120C139.33 190 155 174.33 155 155V70Z",
    fill: "#046FC5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M120 135H110C104.475 135 100 130.525 100 125V35C100 29.475 104.475 25 110 25H120C139.33 25 155 40.67 155 60V170C155 150.67 139.33 135 120 135Z",
    fill: "#7EEAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Moldremediation);
export default __webpack_public_path__ + "static/media/icons8-moldremediation.a23bda15e52b74869b0986bbdb86ff55.svg";
export { ForwardRef as ReactComponent };